import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.19787 1.51543L0.498877 1.5127L0.497514 3.51269L2.36967 3.51397C-1.21264 8.58765 -0.733326 15.6522 3.80761 20.1931L4.51472 20.9002L5.92893 19.486L5.22183 18.7789C1.29991 14.857 0.958594 8.71037 4.19787 4.40123V6.50071H6.19787V1.51543Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.97413 6.63763C6.89318 7.26172 6.52283 8.64391 7.14691 9.72485L11.1787 16.7082L8.59641 17.5885C7.87729 17.8337 7.37667 18.4879 7.32799 19.2461L7.21825 20.9551L13.7363 23.6481C14.5276 23.975 15.4259 23.9158 16.1674 23.4877L22.3036 19.9449C23.3314 19.3515 23.8641 18.167 23.6259 17.0043L22.4943 11.4794C22.2325 10.2016 21.111 9.28206 19.8067 9.27588L15.6098 9.25597C15.1214 9.25365 14.6412 9.3811 14.2183 9.62527L12.7861 10.4522L11.0613 7.46485C10.4373 6.38391 9.05507 6.01355 7.97413 6.63763Z"}}]};

const GestureSlideUpFilled = Vue.extend<IconProps>({
  name: 'GestureSlideUpFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-slide-up-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureSlideUpFilled;
